import PropTypes from 'prop-types';
import React from 'react';

import Checkbox from '../../../common/Checkbox';
import { t } from '../../../../modules/infra/i18n';

const SelectAllFiltersOption = ({ onChange, checked, automationId }) => (
  <Checkbox checked={checked} onChange={e => onChange(e.target.checked)} automationId={automationId}>
    {t('appointment:barbers_filter.select_deselect_all')}
  </Checkbox>
);

SelectAllFiltersOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  automationId: PropTypes.string,
};

SelectAllFiltersOption.defaultProps = {
  automationId: null,
};

export default SelectAllFiltersOption;
